import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useLoading } from "../../../../components/Loading";
import { useEffect, useState } from "react";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";
import DropDownConfig from "../../../Utils/DropDownConfig";


const WorkflowBindingFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const {setCircleLoading} = useLoading();
    const {showSnackbar} = useSnackbar();

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openBinding, setOpenBinding] = useState(false);
    const [openState, setOpenState] = useState(false);
    const [openWorkflowStep, setOpenWorkflowStep] = useState(false);
    const [openEnvironment, setOpenEnvironment] = useState([])

    //options states
    const [bindingOptions, setBindingOptions] = useState([]);
    const [bindingTypeOptions, setBindingTypeOptions] = useState([]);
    const [workflowStepOptions, setWorkflowStepOptions] = useState([]);
    const [environmentOptions, setEnvironmentOptions] = useState([]);
    
    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2px 6px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    useEffect(() => {
        if(!open){
            return;
        }
        fetchBindingList();
    },[open]);

    const fetchBindingList = async () => {
        setCircleLoading(true);
        try {
        const bindingResponse = await fetchData(`/orchestration/key-value-store?code=${DropDownConfig?.operationBinding}&dropdown=true`)        
        if(bindingResponse?.success){
            const formattedBindings = bindingResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || []; 
            setBindingOptions(formattedBindings);  
        }
        else{
            //throw error
            showSnackbar("Error Fetching List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Api List:', error);
            showSnackbar(error?.response?.data?.message || error?.message, "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchBindingTypeList = async () => {
        setCircleLoading(true);
        try {
        const bindingTypeResponse = await fetchData(`/orchestration/key-value-store?code=${DropDownConfig.operationBindingType}&dropdown=true&isActive=true`)
        if(bindingTypeResponse?.success){
            const formattedBindingTypes = bindingTypeResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName
            })) || [];
            setBindingTypeOptions(formattedBindingTypes);  
        }
        else{
            //throw error
            showSnackbar("Error Fetching List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Api List:', error);
            showSnackbar(error?.response?.data?.message || error?.message, "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    const fetchWorkflowBindingList = async () => {
        setCircleLoading(true);
        try {
        const workflowResponse = await fetchData(`/reference/orchestration/work-flow-steps?dropdown=true`)
        if(workflowResponse?.success){
            const formattedWorkflowSteps = workflowResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.stepName,
            })) || [];
            setWorkflowStepOptions(formattedWorkflowSteps);
        }
        }catch(error){
            console.error("Error Fetching Data",error);
            showSnackbar(error?.response?.data?.message || "Error Fetching Data","error");
        }finally{
            setCircleLoading(false);
        }
    };

    const fetchEnvironmentList = async () => {
        setCircleLoading(true);
        try {
        const environmentResponse = await fetchData(`/api-engine/key-value-store?code=${DropDownConfig.apiEnvironment}&dropdown=true`)
        if(environmentResponse?.success){
            const formattedEnvOptions = environmentResponse?.data?.items?.map((item) => ({
                value: item?.id,
                label: item?.keyName,
            })) || [];
            setEnvironmentOptions(formattedEnvOptions);
        }
        }catch(error){
            console.error("Error Fetching Data",error);
            showSnackbar(error?.response?.data?.message || "Error Fetching Data","error");
        }finally{
            setCircleLoading(false);
        }
    };

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            workflowStepId: "",
            bindingId: "",
            bindingTypeId: "",
            environmentId: ""
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 260,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",             
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Workflow Binding Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1} sx={{
        maxHeight: 300, 
        overflowY: "auto"}}>
            <Grid2 container>
                {/* Active */}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Binding*/}
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            setOpenBinding(!openBinding);
                        }}
                        >
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Binding
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openBinding ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openBinding}>
                        {bindingOptions?.map((country) => (
                            <MenuItem
                            key={country.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "bindingId", value: country.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={<Checkbox size="small" checked={filterData.bindingId === country.value} />}
                                label={country.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Binding Type*/}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openState;
                            setOpenState(nextState);
                            if (nextState && bindingTypeOptions.length === 0) {
                                fetchBindingTypeList();
                            }
                        }}                        
                            >
                            <MaterialTypography variant="body3" fontWeight="bold">
                            Binding Type
                            </MaterialTypography>

                            <IconButton size="small">
                            <ExpandMore
                                sx={{
                                transform: openState ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                                }}
                            />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openState}>
                            {bindingTypeOptions?.map((state) => (
                            <MenuItem
                                key={state.value}
                                disableRipple
                                sx={menuItemStyle}
                                onClick={() =>
                                handleChange({
                                    target: { name: "bindingTypeId", value: state.value },
                                })
                                }
                            >
                                <FormControlLabel
                                control={
                                    <Checkbox
                                    size="small"
                                    checked={filterData.bindingTypeId === state.value}
                                    />
                                }
                                label={state.label}
                                sx={labelStyle}
                                />
                            </MenuItem>
                            ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Workflow Step */}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openWorkflowStep;
                            setOpenWorkflowStep(nextState);

                            if (nextState && workflowStepOptions.length === 0) {
                                fetchWorkflowBindingList();
                            }
                        }}>
                            <MaterialTypography variant="body3" fontWeight="bold">
                                Workflow Step
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openWorkflowStep ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openWorkflowStep}>
                        {workflowStepOptions?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "workflowStepId", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.workflowStepId === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                {/* Environment */}
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => {
                            const nextState = !openEnvironment;
                            setOpenEnvironment(nextState);

                            if (nextState && environmentOptions.length === 0) {
                                fetchEnvironmentList();
                            }
                        }}>
                            <MaterialTypography variant="body3" fontWeight="bold">
                                Environment
                            </MaterialTypography>

                            <IconButton size="small">
                                <ExpandMore
                                sx={{
                                    transform: openEnvironment ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "0.2s",
                                }}
                                />
                            </IconButton>
                        </MaterialBox>

                        <Collapse in={openEnvironment}>
                        {environmentOptions?.map((district) => (
                            <MenuItem
                            key={district.value}
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                                handleChange({
                                target: { name: "environmentId", value: district.value },
                                })
                            }
                            >
                            <FormControlLabel
                                control={
                                <Checkbox
                                    size="small"
                                    checked={filterData.environmentId === district.value}
                                />
                                }
                                label={district.label}
                                sx={labelStyle}
                            />
                            </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>
        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            minWidth: "0px",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#bcc7e9",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#93a6e8",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default WorkflowBindingFilterDialog;
